import { Navigate } from "react-router-dom";
import { useFirebase } from "./context";

const NavigationRoute = ({ children }) => {
  const { user, loading } = useFirebase();

  if (loading) return null;
  if (user && !user.isAnonymous) return <Navigate to="/welcome" replace />;

  return children;
};

export default NavigationRoute;
